import { AdvisorMenuId, ClientMenuId, DetailsTabId } from './ids';
import { AdvisorMenuRoute, ClientMenuRoute, Route } from './routes';

export type TabId = string | number | AdvisorMenuId | ClientMenuId;

export interface Tab {
    id: TabId;
    name: string;
    route: Route | AdvisorMenuRoute | ClientMenuRoute | string;
    icon?: string | React.ReactElement;
}

export interface TabMeta<Init = Record<string, unknown>> {
    closeable?: boolean;
    draggable?: boolean;
    poppedOut?: boolean;
    init?: Init;
    height?: string;
    width?: string;
    screenLeft?: string;
    screenTop?: string;
    activeSiblingTabIndex: number;
    siblingTabs: Tab[];
}

export type TabDetails = Omit<Tab, 'route'> & TabMeta;

export const detailsTab: Record<DetailsTabId, Tab> = {
    [DetailsTabId.Account]: {
        id: DetailsTabId.Account,
        name: 'Account Details',
        route: Route.Account,
    },
    [DetailsTabId.User]: {
        id: DetailsTabId.User,
        name: 'User Details',
        route: Route.User,
    },
    [DetailsTabId.Quote]: {
        id: DetailsTabId.Quote,
        name: 'Symbols',
        route: Route.Quote,
    },
    [DetailsTabId.Model]: {
        id: DetailsTabId.Model,
        name: 'Model Details',
        route: Route.Model,
    },
    [DetailsTabId.Group]: {
        id: DetailsTabId.Group,
        name: 'Group Details',
        route: Route.Group,
    },
    [DetailsTabId.NewsArticle]: {
        id: DetailsTabId.NewsArticle,
        name: 'Articles',
        route: Route.NewsArticle,
    },
};
